/*
 * Copyright (c) 2020, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
*/

import {
    FETCH_API_REQUEST, FETCH_API_SUCCESS, FETCH_API_FAILURE, ApiActions,
    FETCH_API_LIST_REQUEST, FETCH_API_LIST_SUCCESS, FETCH_API_LIST_FAILURE,
    FETCH_THUMBNAIL_REQUEST, FETCH_THUMBNAIL_SUCCESS, FETCH_THUMBNAIL_FAILURE,
    FETCH_THUMBNAIL_LIST_REQUEST, FETCH_THUMBNAIL_LIST_SUCCESS, FETCH_THUMBNAIL_LIST_FAILURE, 
    SET_SECURITY_HEADERS,
    FETCH_MAJOR_VERSION_API_LIST_REQUEST,
    FETCH_MAJOR_VERSION_API_LIST_SUCCESS,
    FETCH_MAJOR_VERSION_API_LIST_FAILURE,
    FETCH_FEATURED_API_LIST_SUCCESS,
    FEATCH_FEATURED_API_LIST_REQUEST,
    FETCH_FEATURED_API_LIST_FAILURE,
} from '../types/api';

const initialState = {
    loading: true,
    api: {},
    apiList: {},
    featuredApiList: {},
    featuredApiListLoading: false,
    majorVersionApiList: {},
    majorVersionApisLoading: false,
    apiThumbnailLoading: false,
    apiThumbnail: undefined,
    thumbnailMap: {},
    error: '',
    headers: {
        headerName: '',
        headerValue: ''
    }
}

const apiReducer = (state = initialState, action: ApiActions) => {
    switch (action.type) {
        case FETCH_API_REQUEST:
            return {
                ...state,
                api: {},
                loading: true
            }
        case FETCH_API_SUCCESS:
            return {
                ...state,
                loading: false,
                api: action.payload,
                error: ''
            }
        case FETCH_API_FAILURE:
            return {
                ...state,
                loading: false,
                api: {},
                error: action.payload
            }
        case FETCH_API_LIST_REQUEST:
            return {
                ...state,
                loading: true,
                thumbnailMap: {}
            }
        case FETCH_API_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                apiList: action.payload,
                error: ''
            }
        case FETCH_API_LIST_FAILURE:
            return {
                loading: false,
                apiList: {},
                error: action.payload
            }
        case FEATCH_FEATURED_API_LIST_REQUEST:
            return {
                ...state,
                featuredApiListLoading: true,
                featuredApiList: {},
                thumbnailMap: {}
            }
        case FETCH_FEATURED_API_LIST_SUCCESS:
            return {
                ...state,
                featuredApiListLoading: false,
                featuredApiList: action.payload,
                error: ''
            }
        case FETCH_FEATURED_API_LIST_FAILURE:
            return {
                featuredApiListLoading: false,
                featuredApiList: {},
                error: action.payload
            }
        case FETCH_MAJOR_VERSION_API_LIST_REQUEST:
            return {
                ...state,
                majorVersionApisLoading: true,
                majorVersionApiList: {},
                thumbnailMap: {}
            }
        case FETCH_MAJOR_VERSION_API_LIST_SUCCESS:
            return {
                ...state,
                majorVersionApisLoading: false,
                majorVersionApiList: action.payload,
                error: ''
            }
        case FETCH_MAJOR_VERSION_API_LIST_FAILURE:
            return {
                majorVersionApisLoading: false,
                majorVersionApiList: {},
                error: action.payload
            }
        case FETCH_THUMBNAIL_REQUEST:
            return {
                ...state,
                apiThumbnailLoading: true,
                apiThumbnail: undefined
            }
        case FETCH_THUMBNAIL_SUCCESS:
            return {
                ...state,
                apiThumbnailLoading: false,
                apiThumbnail: action.payload
            }
        case FETCH_THUMBNAIL_FAILURE:
            return {
                ...state,
                apiThumbnailLoading: false,
                apiThumbnail: undefined
            }
        case FETCH_THUMBNAIL_LIST_REQUEST:
            return {
                ...state,
                loading: true,
                thumbnailMap: {}
            }
        case FETCH_THUMBNAIL_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                thumbnailMap: action.payload
            }
        case FETCH_THUMBNAIL_LIST_FAILURE:
            return {
                ...state,
                loading: false,
                thumbnailMap: {}
            }
        case SET_SECURITY_HEADERS:
            return {
                ...state,
                headers: action.payload
            }
        default:
            return state
    }
}

export default apiReducer;
